// @ts-check
import { format } from 'date-fns';

/**
 * format date to yyyy/MM/dd or 2023/09/25
 * @param {Date} date
 * @param {'-'| '/'} [divider]
 */
export function formatOnlyDate(date, divider = '-') {
  return format(date, `yyyy${divider}MM${divider}dd`);
}

/**
 * format date to yyyy-MM-dd hh:mm:ss or 2023-09-25 20:05:22
 * @param {Date} date
 */
export function formatDateTime(date) {
  return format(date, 'yyyy-MM-dd hh:mm:ss');
}

/**
 * format date to yyyy-MM-dd or 2023-09-25
 * @param {Date} date
 */
export function formatSupersetDate(date) {
  return format(date, 'yyyy-MM-dd');
}
